(() => {
  if (window.nxoWishlistBooted || !window.NexoWishlistStore) return;
  const config = document.querySelector('[data-nxo-wishlist-config]');
  const dialog = document.getElementById('NxoWishlist');
  if (!config || !dialog || typeof dialog.showModal !== 'function') return;
  window.nxoWishlistBooted = true;
  const strings = JSON.parse(config.querySelector('script').textContent);
  const store = window.NexoWishlistStore.create(() => window.localStorage);
  const root = config.dataset.root.replace(/\/?$/, '/');
  const currency = config.dataset.currency || 'COP';
  const locale = config.dataset.locale === 'es' && currency === 'COP' ? 'es-CO' : config.dataset.locale;
  const money = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol', ...(currency === 'COP' ? { maximumFractionDigits: 0, minimumFractionDigits: 0 } : {}) });
  const list = dialog.querySelector('[data-nxo-wishlist-list]');
  const empty = dialog.querySelector('[data-nxo-wishlist-empty]');
  const announcement = document.querySelector('[data-nxo-wishlist-announcement]');
  const status = dialog.querySelector('[data-nxo-wishlist-status]');
  const titles = new Map();
  const cache = new Map();
  const requests = new Set();
  let renderVersion = 0;
  let opener = null;
  let previousOverflow = '';
  let closeTimer = null;
  const track = (action, handle, source, productId) => window.NexoWishlistAnalytics?.track(action, { handle, source, productId: productId || cache.get(handle)?.product.id, productTitle: handle ? titleFor(handle) : undefined, count: store.read().length });
  const text = (name, value) => strings[name].replace('[product]', value).replace('[count]', value);
  const productUrl = handle => `${root}products/${encodeURIComponent(handle)}`;
  const titleFor = handle => titles.get(handle) || cache.get(handle)?.product.title || handle.replace(/-/g, ' ');
  const announce = message => {
    announcement.textContent = message;
    status.textContent = message;
  };
  const sync = () => {
    const handles = store.read();
    document.querySelectorAll('[data-nxo-favorite]').forEach(button => {
      const handle = button.dataset.nxoFavorite;
      const title = button.dataset.favoriteTitle;
      if (title) titles.set(handle, title);
      const saved = handles.includes(handle);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', text(saved ? 'removeProduct' : 'saveProduct', titleFor(handle)));
      const label = button.querySelector('[data-nxo-favorite-label]');
      if (label) label.textContent = strings[saved ? 'saved' : 'save'];
    });
    document.querySelectorAll('[data-nxo-wishlist-open]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-label', text('count', handles.length));
      const badge = button.querySelector('[data-nxo-wishlist-count]');
      if (badge) { badge.textContent = handles.length; badge.hidden = !handles.length; }
    });
    if (!store.isPersistent()) dialog.querySelector('[data-nxo-wishlist-storage]').textContent = strings.session;
    return handles;
  };
  const node = (tag, className, content) => {
    const element = document.createElement(tag);
    element.className = className;
    if (content !== undefined) element.textContent = content;
    return element;
  };
  const removeIcon = () => {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'm6 6 12 12M18 6 6 18');
    svg.append(path);
    return svg;
  };
  const safeImage = source => {
    try {
      const url = new URL(source, location.origin);
      return url.protocol === 'https:' ? url.href : '';
    } catch { return ''; }
  };
  const paintRow = (row, handle, result) => {
    const restoreRemoveFocus = row.contains(document.activeElement) && document.activeElement.hasAttribute('data-nxo-wishlist-remove');
    const title = result.product?.title || titleFor(handle);
    if (result.product) titles.set(handle, title);
    row.replaceChildren();
    row.dataset.nxoWishlistItem = handle;
    const image = node(result.product ? 'a' : 'div', 'nxo-wishlist__image');
    if (result.product) { image.href = productUrl(handle); image.setAttribute('aria-label', title); }
    const imageUrl = result.product?.featured_image && safeImage(result.product.featured_image);
    if (imageUrl) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      img.width = 88;
      img.height = 110;
      img.loading = 'lazy';
      image.append(img);
    }
    const details = node('div', 'nxo-wishlist__details');
    const heading = node('h3', 'nxo-wishlist__title');
    if (result.product) {
      const link = node('a', '', title);
      link.href = productUrl(handle);
      heading.append(link);
    } else heading.textContent = title;
    details.append(heading);
    let caption = strings.loading;
    if (result.product) {
      caption = `${result.product.price_varies ? strings.from + ' ' : ''}${money.format(result.product.price / 100)}`;
      if (!result.product.available) caption += ` · ${strings.soldOut}`;
    } else if (result.unavailable) caption = strings.unavailable;
    else if (result.error) caption = strings.error;
    details.append(node('p', 'nxo-wishlist__price', caption));
    if (result.product) {
      const view = node('a', 'nxo-wishlist__view', strings.view);
      view.href = productUrl(handle);
      details.append(view);
    } else if (result.error) {
      const retry = node('button', 'nxo-wishlist__retry', strings.retry);
      retry.type = 'button';
      retry.dataset.nxoWishlistRetry = handle;
      details.append(retry);
    }
    const remove = node('button', 'nxo-wishlist__remove');
    remove.type = 'button';
    remove.dataset.nxoWishlistRemove = handle;
    remove.setAttribute('aria-label', text('removeProduct', title));
    remove.append(removeIcon());
    row.append(image, details, remove);
    row.setAttribute('aria-busy', String(!result.product && !result.error && !result.unavailable));
    if (restoreRemoveFocus) remove.focus();
  };
  const getProduct = async handle => {
    const cached = cache.get(handle);
    if (cached && Date.now() - cached.at < 60000) return { product: cached.product };
    const controller = new AbortController();
    requests.add(controller);
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(`${productUrl(handle)}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
      if (response.status === 404) return { unavailable: true };
      if (!response.ok) throw new Error('Product request failed');
      const product = await response.json();
      if (product.handle !== handle || typeof product.title !== 'string' || !Number.isFinite(product.price)) throw new Error('Invalid product');
      cache.set(handle, { at: Date.now(), product });
      return { product };
    } catch { return { error: true }; }
    finally { clearTimeout(timeout); requests.delete(controller); }
  };
  const cancelRequests = () => { requests.forEach(controller => controller.abort()); requests.clear(); };
  const render = async () => {
    const version = ++renderVersion;
    cancelRequests();
    const handles = sync();
    empty.hidden = !!handles.length;
    list.hidden = !handles.length;
    const rows = new Map();
    const fragment = document.createDocumentFragment();
    handles.forEach(handle => {
      const row = node('li', 'nxo-wishlist__item');
      paintRow(row, handle, {});
      rows.set(handle, row);
      fragment.append(row);
    });
    list.replaceChildren(fragment);
    let next = 0;
    await Promise.all(Array.from({ length: Math.min(4, handles.length) }, async () => {
      while (version === renderVersion && dialog.open && next < handles.length) {
        const handle = handles[next++];
        const result = await getProduct(handle);
        if (version !== renderVersion || !dialog.open) return;
        paintRow(rows.get(handle), handle, result);
      }
    }));
  };
  const open = button => {
    if (dialog.open) return;
    opener = button;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    render();
    track('opened', undefined, 'header');
  };
  const close = () => {
    if (!dialog.open || closeTimer !== null) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    closeTimer = setTimeout(() => { closeTimer = null; dialog.close(); }, 360);
  };
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    clearTimeout(closeTimer);
    closeTimer = null;
    dialog.classList.remove('is-closing');
    ++renderVersion;
    cancelRequests();
    document.body.style.overflow = previousOverflow;
    if (opener?.isConnected) opener.focus();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  document.addEventListener('click', event => {
    const productLink = event.target.closest('.nxo-wishlist__item a');
    if (productLink) {
      const receipt = track('product_viewed', productLink.closest('[data-nxo-wishlist-item]').dataset.nxoWishlistItem, 'drawer');
      if (event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !productLink.hasAttribute('download') && (!productLink.target || productLink.target === '_self')) {
        event.preventDefault();
        let navigationTimer;
        Promise.race([Promise.resolve(receipt), new Promise(resolve => { navigationTimer = setTimeout(resolve, 180); })]).finally(() => {
          clearTimeout(navigationTimer);
          window.location.assign(productLink.href);
        });
      }
    }
    const button = event.target.closest('[data-nxo-favorite], [data-nxo-wishlist-open], [data-nxo-wishlist-close], [data-nxo-wishlist-remove], [data-nxo-wishlist-retry]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.hasAttribute('data-nxo-favorite')) {
      const handle = button.dataset.nxoFavorite;
      const result = store.toggle(handle);
      sync();
      announce(result.full ? strings.limit : text(result.saved ? 'added' : 'removed', titleFor(handle)));
      if (!result.full && !result.invalid) track(result.saved ? 'saved' : 'removed', handle, button.dataset.favoriteSource, button.dataset.favoriteId);
      if (dialog.open) render();
    } else if (button.hasAttribute('data-nxo-wishlist-open')) open(button);
    else if (button.hasAttribute('data-nxo-wishlist-close')) close();
    else if (button.hasAttribute('data-nxo-wishlist-remove')) {
      const handle = button.dataset.nxoWishlistRemove;
      const index = [...list.children].indexOf(button.closest('[data-nxo-wishlist-item]'));
      store.remove(handle);
      track('removed', handle, 'drawer');
      render();
      announce(text('removed', titleFor(handle)));
      const buttons = list.querySelectorAll('[data-nxo-wishlist-remove]');
      (buttons[Math.min(index, buttons.length - 1)] || dialog.querySelector('[data-nxo-wishlist-close]')).focus();
    } else {
      const handle = button.dataset.nxoWishlistRetry;
      const row = button.closest('[data-nxo-wishlist-item]');
      const version = renderVersion;
      paintRow(row, handle, {});
      getProduct(handle).then(result => {
        if (version === renderVersion && dialog.open && row.isConnected) {
          paintRow(row, handle, result);
          row.querySelector('a, button')?.focus();
        }
      });
    }
  }, true);
  // Observe successful native adds; quantity comes from the submission, not the merged cart line.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    const pendingAdds = new Map();
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || (!form.closest('product-form') && !form.hasAttribute('data-nxo-flash-form'))) return;
      const button = form.querySelector('[type="submit"]');
      if (button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
      const values = new FormData(form);
      const variantId = String(values.get('id') || '');
      const quantity = Number(values.get('quantity') || 1);
      if (!/^\d+$/.test(variantId) || !Number.isInteger(quantity) || quantity < 1 || quantity > 9999) return;
      for (const [id, pending] of pendingAdds) if (Date.now() - pending.at > 90000) pendingAdds.delete(id);
      pendingAdds.set(variantId, { quantity, at: Date.now() });
    }, true);
    subscribe(PUB_SUB_EVENTS.cartError, data => pendingAdds.delete(String(data.productVariantId || '')));
    subscribe(PUB_SUB_EVENTS.cartUpdate, data => {
      if (!['product-form', 'nxo-cart-flash'].includes(data.source)) return;
      const variantId = String(data.productVariantId || '');
      const pending = pendingAdds.get(variantId);
      pendingAdds.delete(variantId);
      const product = data.cartData;
      if (!pending || Date.now() - pending.at > 90000 || !product || product.status || product.errors || !store.read().includes(product.handle)) return;
      window.NexoWishlistAnalytics?.track('added_to_cart', {
        handle: product.handle, productId: product.product_id, productTitle: product.product_title || product.title,
        source: 'product', count: store.read().length, quantity: pending.quantity,
        price: Number(product.final_price ?? product.price) / 100
      });
    });
  }
  window.addEventListener('storage', event => {
    if (event.key !== window.NexoWishlistStore.key && event.key !== null) return;
    sync();
    if (dialog.open) render();
  });
  let syncQueued = false;
  new MutationObserver(records => {
    const changed = records.some(record => [...record.addedNodes].some(item => item.nodeType === 1 && (item.matches('[data-nxo-favorite], [data-nxo-wishlist-open]') || item.querySelector('[data-nxo-favorite], [data-nxo-wishlist-open]'))));
    if (!changed || syncQueued) return;
    syncQueued = true;
    queueMicrotask(() => { syncQueued = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true });
  sync();
  document.documentElement.classList.add('nxo-wishlist-ready');
})();

